import * as Yup from 'yup';

import { EMAILED_CODE_VALIDATION_ERRORS } from '@modules/core/constants';

const validationSchema = Yup.object().shape({
  verificationCode: Yup.string().required(EMAILED_CODE_VALIDATION_ERRORS.required),
});

export default validationSchema;
